import {
  POPULATE_OTA_VEHICLES,
  POPULATE_OTA_FILTER_PARAMS,
  POPULATE_SC_VERSIONS,
  POPULATE_MD_VERSIONS,
  POPULATE_BMS_VERSIONS,
  POPULATE_FIRMWARE_PACKAGES,
  POPULATE_GEOFENCE_PACKAGES,
  POPULATE_FIRMWARE_PACKAGE_APPLICATIONS,
  POPULATE_GEOFENCE_PACKAGE_APPLICATIONS,
  POPULATE_GEOFENCE_MAP_IDS,
  POPULATE_GEOFENCE_RULE_IDS,
  POPULATE_TARGET_GEOFENCE,
  POPULATE_TARGET_FIRMWARE,
  POPULATE_IN_PROGRESS_FPA_COUNT,
  POPULATE_IN_PROGRESS_GPA_COUNT,
  POPULATE_LG69T_GNSS_VERSIONS,
  POPULATE_LG69T_APP_VERSIONS,
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case POPULATE_IN_PROGRESS_FPA_COUNT:
      return {
        ...state,
        inProgressFpaCount: { ...state.inProgressFpaCount, ...action.payload },
      };
    case POPULATE_IN_PROGRESS_GPA_COUNT:
      return {
        ...state,
        inProgressGpaCount: { ...state.inProgressGpaCount, ...action.payload },
      };
    case POPULATE_SC_VERSIONS:
      return {
        ...state,
        scVersions: action.payload,
      };
    case POPULATE_MD_VERSIONS:
      return {
        ...state,
        mdVersions: action.payload,
      };
    case POPULATE_BMS_VERSIONS:
      return {
        ...state,
        bmsVersions: action.payload,
      };
    case POPULATE_GEOFENCE_MAP_IDS:
      return {
        ...state,
        geofenceMapIds: action.payload,
      };
    case POPULATE_GEOFENCE_RULE_IDS:
      return {
        ...state,
        geofenceRuleIds: action.payload,
      };
    case POPULATE_FIRMWARE_PACKAGES:
      return {
        ...state,
        firmwarePackages: action.payload,
      };
    case POPULATE_GEOFENCE_PACKAGES:
      return {
        ...state,
        geofencePackages: action.payload,
      };
    case POPULATE_FIRMWARE_PACKAGE_APPLICATIONS:
      return {
        ...state,
        firmwarePackageApplications: action.payload,
      };
    case POPULATE_GEOFENCE_PACKAGE_APPLICATIONS:
      return {
        ...state,
        geofencePackageApplications: action.payload,
      };
    case POPULATE_OTA_VEHICLES:
      return {
        ...state,
        otaVehicles: action.payload,
      };
    case POPULATE_OTA_FILTER_PARAMS:
      return {
        ...state,
        otaFilterParams: { ...state.otaFilterParams, ...action.payload },
      };
    case POPULATE_TARGET_GEOFENCE:
      return {
        ...state,
        geofenceTargetPackage: action.payload,
      };
    case POPULATE_TARGET_FIRMWARE:
      return {
        ...state,
        firmwareTargetPackage: action.payload,
      };
    case POPULATE_LG69T_GNSS_VERSIONS:
      return {
        ...state,
        lg69tGnssVersions: action.payload,
      };
    case POPULATE_LG69T_APP_VERSIONS:
      return {
        ...state,
        lg69tAppVersions: action.payload,
      };
    default:
      return state;
  }
};
